import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React, { useEffect } from "react";
import { Route, Switch, useRouteMatch } from "react-router";
import { Link } from "react-router-dom";

import CompareTable from "../components/CompareTable";
import howitworks from "../img/howitworks.png";
import Joincode from "../img/Joincode.png";
import Selectclass from "../img/Selectclass.png";
import differencetable from "../img/differencetable.png";
import Studentstab from "../img/Studentstab.png";
import Addmanuallyorjoin from "../img/Addmanuallyorjoin.png";
import Manuallyaddstudents from "../img/Manuallyaddstudents.png";

const useStyles = makeStyles((theme) => ({
  topicMain: {},
  root: {
    minHeight: "50vh",
    marginTop: "70px",
    paddingBottom: "50px",
    width: "100%",
    maxWidth: "800px",
    "& a": {
      color: "#4381b5",
    },
    "& img": {
      boxShadow: "0 3px 10px rgb(0 0 0 / 0.4)",
      borderRadius: "4px",
      // transition: "transform .2s",
      // "&:hover": {
      //   transform: "scale(1.3)",
      // },
    },
    "& ul": { marginLeft: "20px" },
    "& li": {
      marginLeft: "20px",
    },
  },
  imgSize: {
    maxWidth: "350px",
    width: "90%",
    display: "block",
    margin: "20px auto",
    marginBottom: "40px",
  },
  imgSize2: {
    maxWidth: "370px",
    width: "90%",
    margin: "20px auto",
    display: "block",
    marginTop: "20px",
  },
  imgSize3: {
    maxWidth: "250px",
    width: "80%",
    margin: "15px 20px 0px 20px",
    display: "block",
  },
  hyperlink: {
    textDecoration: "none",
    color: "#8277FF !important",
  },
  fontHeading: {
    marginBottom: "40px",
    fontSize: "28px",
    [theme.breakpoints.down("xs")]: {
      fontSize: "22px",
    },
  },
  highlighted: {
    backgroundColor: "#d8d2e7",
    width: "max-content",
    borderLeft: "5px solid #d8d2e7",
    borderRight: "5px solid #d8d2e7",
  },
}));

function HowDoesWork() {
  const classes = useStyles();
  return (
    <div>
      <div className={classes.root}>
        <div>
          <Typography variant="h5" className={classes.fontHeading}>
            How does SwiftGrade work?
          </Typography>
        </div>
        <div display="block">
          <div>
            <Typography
              className={classes.details}
              display="block"
              variant="body2"
            >
              SwiftGrade is based on answer sheets. <br />
              <br />
              In summary, teachers create an answer key, students respond in our
              answer sheets, and then SwiftGrade compares the two to generate
              results.
              <br />
              <br />
              Note that you never input your test questions into SwiftGrade.
              Instead, you only input your answers.
              <br />
              <br />
              For more details, see the illustration below:
            </Typography>
            <br />

            <img
              alt="howitworks"
              style={{ maxWidth: "700px" }}
              className={classes.imgSize}
              src={howitworks}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

function DifferencesBetween() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div>
        <Typography variant="h5" className={classes.fontHeading}>
          What is the difference between the SwiftGrade Website and the iOS
          /Android app?
        </Typography>
      </div>
      <div display="block">
        <Typography className={classes.details} display="block" variant="body2">
          Our website allows you to do everything except scan paper answer
          sheets with your phone’s camera – for that you need the SwiftGrade
          App.
          <br />
          <br />
          Our App is mostly meant for quickly creating multiple-choice answer
          keys, scanning paper answer sheets, and viewing basic results on the
          fly.
          <br />
          <br />
          For a detailed breakdown of our Website vs. App, see the table below:
        </Typography>
        <img
          src={differencetable}
          style={{ maxWidth: "600px", borderRadius: "0px", width: "100%" }}
          className={classes.imgSize2}
        />

        <Typography className={classes.details} display="block" variant="body2">
          We recommend that you use our website for everything but scanning
          answer sheets.
        </Typography>
      </div>
    </div>
  );
}
function DoINeed() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div>
        <Typography variant="h5" className={classes.fontHeading}>
          Do I need to create or upload my questions on SwiftGrade?
        </Typography>
      </div>
      <div display="block">
        <Typography className={classes.details} variant="body2">
          No, you do not. SwiftGrade works independently of your assessment
          questions. For example, your questions could be written on your
          classroom’s whiteboard, be in a textbook, or even in a video.
          <br />
          <br />
          Therefore, with SwiftGrade you only need to input your answers and
          then have students respond in our online or paper answer sheets.
          <br />
          <br />A good analogy is Scantron forms. SwiftGrade can do so much more
          than Scantron forms, but the underlying principle of creating an
          answer key and having students respond in answer sheets is the same.
        </Typography>
      </div>
    </div>
  );
}
function DoINeedAdd() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div>
        <Typography variant="h5" className={classes.fontHeading}>
          Do I need to add students to my classes?
        </Typography>
      </div>
      <div display="block">
        <Typography className={classes.details} variant="body2">
          <span style={{ textDecoration: "underline" }}>
            Paper assessments:
          </span>{" "}
          Students can take paper assessments without joining any of your
          classes. However, if a student is not a part of your class, you won’t
          be able to release results to them unless they write their email
          address in their answer sheet.
          <br />
          <br />
          <span style={{ textDecoration: "underline" }}>
            Online assessments:
          </span>{" "}
          Students must be a part of your class to take online assessments.
        </Typography>
      </div>
    </div>
  );
}
function TutorialGradeSteps() {
  useEffect(() => {
    const script1 = document.createElement("script");
    const script2 = document.createElement("script");

    script1.src = "https://fast.wistia.com/embed/medias/twpkd7fmxs.jsonp";
    script1.async = true;

    script2.src = "https://fast.wistia.com/assets/external/E-v1.js";
    script2.async = true;

    document.body.appendChild(script1);
    document.body.appendChild(script2);
  }, []);
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div style={{ display: "inline-block" }}>
        <div>
          <Typography variant="h5" className={classes.fontHeading}>
            Tutorial video: How to grade assessments in 3 simple steps
          </Typography>
        </div>
        <Typography className={classes.details} variant="body2">
          SwiftGrade works in three simple steps as demonstrated in this video:
        </Typography>
        <div
          className="wistia_responsive_padding"
          style={{ padding: "100.0% 0 0 0", position: "relative" }}
        >
          <div
            className="wistia_responsive_wrapper"
            style={{
              height: "100%",
              boxShadow: "0 3px 10px rgb(0 0 0 / 0.2)",
              borderRadius: "4px",
              left: 0,
              position: "absolute",
              top: 0,
              width: "100%",
              marginBottom: "30px",
              marginTop: "30px",
            }}
          >
            <div
              className="wistia_embed wistia_async_twpkd7fmxs seo=false videoFoam=true"
              style={{ height: "100%", position: "relative", width: "100%" }}
            >
              <div
                className="wistia_swatch"
                style={{
                  height: "100%",
                  left: 0,
                  opacity: 0,
                  overflow: "hidden",
                  position: "absolute",
                  top: 0,
                  transition: "opacity 200ms",
                  width: "100%",
                }}
              >
                <img
                  src="https://fast.wistia.com/embed/medias/twpkd7fmxs/swatch"
                  style={{
                    filter: "blur(5px)",
                    height: "100%",
                    objectFit: "contain",
                    width: "100%",
                  }}
                  alt=""
                  aria-hidden="true"
                  onload="this.parentNode.style.opacity=1;"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
function VideoFeatures() {
  useEffect(() => {
    const script1 = document.createElement("script");
    const script2 = document.createElement("script");

    script1.src = "https://fast.wistia.com/embed/medias/qt2buyw26r.jsonp";
    script1.async = true;

    script2.src = "https://fast.wistia.com/assets/external/E-v1.js";
    script2.async = true;

    document.body.appendChild(script1);
    document.body.appendChild(script2);
  }, []);
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div style={{ display: "inline-block" }}>
        <div>
          <Typography variant="h5" className={classes.fontHeading}>
            Info video: SwiftGrade features{" "}
          </Typography>
        </div>
        <Typography className={classes.details} variant="body2">
          See some of SwiftGrade’s features such as setting a tolerance range
          for numeric answers, auto-correcting spelling errors, giving part
          marks, plus more in the video below:
        </Typography>
        <div
          className="wistia_responsive_padding"
          style={{ padding: "56.25% 0 0 0", position: "relative" }}
        >
          <div
            className="wistia_responsive_wrapper"
            style={{
              height: "100%",
              boxShadow: "0 3px 10px rgb(0 0 0 / 0.2)",
              borderRadius: "4px",
              left: 0,
              position: "absolute",
              top: 0,
              width: "100%",
              marginBottom: "30px",
              marginTop: "30px",
            }}
          >
            <div
              className="wistia_embed wistia_async_qt2buyw26r videoFoam=true"
              style={{ height: "100%", position: "relative", width: "100%" }}
            >
              <div
                className="wistia_swatch"
                style={{
                  height: "100%",
                  left: 0,
                  opacity: 0,
                  overflow: "hidden",
                  position: "absolute",
                  top: 0,
                  transition: "opacity 200ms",
                  width: "100%",
                }}
              >
                <img
                  src="https://fast.wistia.com/embed/medias/qt2buyw26r/swatch"
                  style={{
                    filter: "blur(5px)",
                    height: "100%",
                    objectFit: "contain",
                    width: "100%",
                  }}
                  alt=""
                  aria-hidden="true"
                  onload="this.parentNode.style.opacity=1;"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
function HowToAdd() {
  const classes = useStyles();
  return (
    <div className={classes.root} style={{ maxWidth: "900px" }}>
      <div>
        <Typography variant="h5" className={classes.fontHeading}>
          How to add students to your class:
        </Typography>
      </div>
      <div display="block">
        <Typography className={classes.details} variant="body2">
          <a href="#getting-started">Getting started</a>
          <br />
          <br />
          <a href="#manually-adding-students">Manually adding students</a>
          <br />
          <br />
          <a href="#inviting-students">Inviting students</a>
          <br />
          <br />
        </Typography>
        <Typography
          className={classes.highlighted}
          variant="h6"
          id="getting-started"
        >
          Getting started
        </Typography>
        <Typography className={classes.details} variant="body2">
          To add students, first select a class from your dashboard: :
        </Typography>
        <img
          alt="add to class"
          style={{ maxWidth: "900px" }}
          className={classes.imgSize}
          src={Selectclass}
        />
        <Typography className={classes.details} variant="body2">
          Go to the Students tab and then click ‘+ Students’:
        </Typography>
        <img
          alt="students tab"
          style={{ maxWidth: "900px" }}
          className={classes.imgSize}
          src={Studentstab}
        />
        <Typography className={classes.details} variant="body2">
          Now, you have the option to manually add students yourself, or invite
          them to join on their own:
        </Typography>
        <img
          alt="students tab"
          style={{ maxWidth: "900px" }}
          className={classes.imgSize}
          src={Addmanuallyorjoin}
        />

        <Typography
          className={classes.highlighted}
          variant="h6"
          id="manually-adding-students"
        >
          Manually adding Students
        </Typography>
        <Typography className={classes.details} variant="body2">
          If you select ‘Add manually’, you can type a single student, or copy
          and paste your entire class list into the table below:
        </Typography>
        <img
          alt="students tab"
          style={{ maxWidth: "900px" }}
          className={classes.imgSize}
          src={Manuallyaddstudents}
        />
        <ul>
          <Typography className={classes.details} variant="body2">
            <li>
              You can auto-generate usernames and passwords, instead of having
              to create them on your own.
              <br />
              <br />
            </li>
            <li>
              Students with only a username will be asked to add their email
              upon first log in. This email will become their new username.
              <br />
              <br />
            </li>
          </Typography>
        </ul>
        <Typography
          className={classes.highlighted}
          variant="h6"
          id="inviting-students"
        >
          Inviting students
        </Typography>
        <Typography className={classes.details} variant="body2">
          If you select ‘Invite students’, a class code will be given:
        </Typography>
        <img
          alt="students tab"
          style={{ maxWidth: "900px" }}
          className={classes.imgSize}
          src={Joincode}
        />
        <Typography className={classes.details} variant="body2">
          Give this code to your students, and tell them to visit{" "}
          <a
            target="_blank"
            rel="noreferrer noopener"
            className={classes.hyperlink}
            href="https://app.goswiftgrade.com/join/"
          >
            goswiftgrade.com/join
          </a>{" "}
          to get started.
          <br />
          <br />
          For instructions to students on how to use your code to join a class,
          see this{" "}
          <Link
            className={classes.hyperlink}
            to="/help-topics/getting-started-topics/how-can-i-join"
          >
            help article
          </Link>
          .
        </Typography>
      </div>
    </div>
  );
}

function KeyIdeaTopics() {
  const { path } = useRouteMatch();

  return (
    <>
      <Switch>
        <Route path={`${path}/how-does-swiftgrade-work`}>
          <HowDoesWork />
        </Route>
        <Route path={`${path}/grade-in-3-steps`}>
          <TutorialGradeSteps />
        </Route>
        <Route path={`${path}/info-video-swiftgrade-features`}>
          <VideoFeatures />
        </Route>
        <Route path={`${path}/differences-between-android`}>
          <DifferencesBetween />
        </Route>
        <Route path={`${path}/do-i-need-to-upload`}>
          <DoINeed />
        </Route>
        <Route path={`${path}/do-i-need-to-add`}>
          <DoINeedAdd />
        </Route>
        <Route path={`${path}/how-to-add-students`}>
          <HowToAdd />
        </Route>
      </Switch>
    </>
  );
}

export default KeyIdeaTopics;
